import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import client from '../../api/client';

export const fetchAttendance = createAsyncThunk('attendance/fetchAll', async (params) => {
  const { data } = await client.get('/attendance/', { params });
  return data;
});

export const markAttendance = createAsyncThunk('attendance/mark', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await client.post('/attendance/', payload);
    return data;
  } catch (err) {
    return rejectWithValue(err.response?.data);
  }
});

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAttendance.pending, state => { state.loading = true; })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.results || action.payload;
      })
      .addCase(markAttendance.fulfilled, (state, action) => {
        const idx = state.list.findIndex(a => a.id === action.payload.id);
        if (idx >= 0) state.list[idx] = action.payload;
        else state.list.push(action.payload);
      });
  }
});

export default attendanceSlice.reducer;
